import mixpanel from 'trackers/mixpanel'
import type { Surface } from 'types/project'

export const PaletteEvent = {
  PaletteOpened: 'Palette Opened',
  PaletteCommandExecuted: 'Palette Command Executed',
} as const

export interface PaletteOpenedProps {
  proj_uuid?: string
  surface?: Surface
}

export interface PaletteCommandExecutedProps {
  proj_uuid?: string
  surface?: Surface
  command_id: string
  section: string
  query_length: number
  result_rank: number
}

export const trackPaletteOpened = (props: PaletteOpenedProps): void => {
  mixpanel.track(PaletteEvent.PaletteOpened, props)
}

export const trackPaletteCommandExecuted = (
  props: PaletteCommandExecutedProps,
): void => {
  mixpanel.track(PaletteEvent.PaletteCommandExecuted, props)
}
